import React from 'react';
import Operations from './components/Operations';
import Customers from './components/Customers';
import WeatherWidget from './components/WeatherWidget';
import styles from './ExecutePage.module.css';

const ExecutePage = () => {
  return (
    <div className={styles.executePage}>
      <div className={styles.contentRow}>
        <div className={styles.operationsSection}>
          <Operations />
        </div>
        <div className={styles.customersSection}>
          <Customers />
        </div>
        <div className={styles.weatherSection}>
          <WeatherWidget />
        </div>
      </div>
    </div>
  );
};

export default ExecutePage;
